document.addEventListener('DOMContentLoaded', function () {
  var section = document.getElementById('lab-section');
  if (!section) return;
  var inner = section.querySelector('.lab-accordion-inner');
  var loader = document.getElementById('lab-loader');
  var fill = document.getElementById('lab-loader-fill');
  var pct = document.getElementById('lab-loader-pct');
  var closeBtn = document.getElementById('lab-close');
  var titleEl = section.querySelector('.lab-accordion-title');
  var iframeSrc = 'https://portal.anresco.com/#/companypage?hash=47172ba501c0c6822151cc61602a9291388e84e106bca13b9aae4f6ee6b28e5e';
  var loaded = false;
  var progressTimer = null;

  // --- Scramble effect ---
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%&*';
  var textFrom = 'LAB RESULTS';
  var textTo = 'BACK TO 9LOKO';
  var scrambleTimer = null;

  function scramble(from, to, callback) {
    if (scrambleTimer) clearInterval(scrambleTimer);
    var len = Math.max(from.length, to.length);
    var iterations = 0;
    var resolved = [];
    for (var i = 0; i < len; i++) resolved[i] = false;

    var totalFrames = Math.ceil(333 / 16);
    var resolveEvery = Math.max(1, Math.floor(totalFrames / len));

    scrambleTimer = setInterval(function () {
      var result = '';
      var allDone = true;
      for (var i = 0; i < len; i++) {
        if (resolved[i]) {
          result += to[i] || '';
        } else if (iterations >= i * resolveEvery) {
          resolved[i] = true;
          result += to[i] || '';
        } else {
          allDone = false;
          result += chars[Math.floor(Math.random() * chars.length)];
        }
      }
      titleEl.textContent = result;
      iterations++;
      if (allDone || iterations >= totalFrames) {
        clearInterval(scrambleTimer);
        scrambleTimer = null;
        titleEl.textContent = to;
        if (callback) callback();
      }
    }, 16);
  }

  closeBtn.addEventListener('mouseenter', function () {
    scramble(titleEl.textContent, textTo);
  });
  closeBtn.addEventListener('mouseleave', function () {
    scramble(titleEl.textContent, textFrom);
  });

  // --- Progress bar loader ---
  function startProgress(onComplete) {
    var progress = 0;
    var iframeReady = false;
    var target = 90; // crawl to 90%, then jump to 100% when iframe loads

    if (fill) fill.style.width = '0%';
    if (pct) pct.textContent = '0%';
    if (loader) {
      loader.classList.remove('hidden');
      loader.style.opacity = '1';
    }

    function updateBar(val) {
      var rounded = Math.round(val);
      if (fill) fill.style.width = rounded + '%';
      if (pct) pct.textContent = rounded + '%';
    }

    progressTimer = setInterval(function () {
      if (iframeReady) {
        progress += 3;
        if (progress >= 100) {
          progress = 100;
          clearInterval(progressTimer);
          progressTimer = null;
          updateBar(100);
          setTimeout(function () {
            if (loader) {
              loader.style.transition = 'opacity 0.5s ease';
              loader.style.opacity = '0';
              setTimeout(function () {
                loader.style.display = 'none';
              }, 500);
            }
          }, 400);
          return;
        }
      } else {
        var remaining = target - progress;
        progress += remaining * 0.02 + 0.3;
        if (progress >= target) progress = target;
      }
      updateBar(progress);
    }, 50);

    return function () {
      iframeReady = true;
    };
  }

  function openLab() {
    titleEl.textContent = textFrom;
    section.style.display = 'block';
    section.offsetHeight;
    section.classList.add('open');
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (!loaded) {
      var markReady = startProgress();
      var iframe = document.createElement('iframe');
      iframe.src = iframeSrc;
      iframe.className = 'lab-iframe';
      iframe.setAttribute('loading', 'lazy');
      iframe.setAttribute('title', 'Lab Results - Anresco');
      iframe.onload = function () {
        markReady();
      };
      inner.appendChild(iframe);
      loaded = true;
    }
  }

  function closeLab() {
    if (scrambleTimer) clearInterval(scrambleTimer);
    if (progressTimer) clearInterval(progressTimer);
    titleEl.textContent = textFrom;
    section.classList.remove('open');
    setTimeout(function () {
      section.style.display = 'none';
    }, 600);
    var hero = document.getElementById('home');
    if (hero) hero.scrollIntoView({ behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#lab-results-btn') || e.target.closest('.lab-results-btn')) {
      e.preventDefault();
      openLab();
    }
  });

  closeBtn.addEventListener('click', closeLab);
});
